import { forwardRef } from '@heroui/system';
import { extendVariants, Button, ButtonProps } from '@heroui/react';

export const CustomButton = extendVariants(Button, {
  variants: {
    variant: {
      solid:
        'bg-base-5 data-[hover=true]:bg-base-10 data-[hover=true]:opacity-100! data-[pressed=true]:bg-base-10 tmdx-button--solid shrink-0',
      outline:
        'bg-transparent text-base-5 border border-base-5 border-solid data-[hover=true]:bg-base-55 data-[hover=true]:opacity-100! data-[pressed=true]:bg-base-55 tmdx-button--outline shrink-0',
      light:
        'bg-transparent text-base-5 data-[hover=true]:bg-base-55 data-[hover=true]:opacity-100! active:bg-base-55 tmdx-button--light shrink-0',
    },
    size: {
      sm: 'h-7.5 px-4 [&>svg]:w-4.5 [&>svg]:h-4.5 tmdx-button tmdx-button--sm',
      md: 'h-9 [&>svg]:w-4.5 [&>svg]:h-4.5 tmdx-button tmdx-button--md',
      lg: 'h-12 tmdx-button tmdx-button--lg',
    },
    isDisabled: {
      true: 'opacity-40 cursor-not-allowed',
    },
    color: {
      danger: 'tmdx-button--danger',
    },
  },
  defaultVariants: {
    variant: 'solid',
    size: 'lg',
  },
  compoundVariants: [
    {
      class: 'gap-2',
    },
  ],
});

export interface CustomButtonProps extends Omit<ButtonProps, 'variant' | 'ref'> {
  variant?: 'solid' | 'light' | 'outline';
}

const ButtonWrapper = forwardRef<'button', CustomButtonProps>((props, ref) => {
  const { children, ...restProps } = props;
  return (
    <CustomButton ref={ref} radius="full" {...restProps}>
      {children}
    </CustomButton>
  );
});

ButtonWrapper.displayName = 'CustomButton';

export default ButtonWrapper;
